
export class GeneralsettingetResponseModel {
  public createdBy: string;
  public createdDate: string;
  public modifiedBy: string;
  public modifiedDate: string;
  public settingsId: number;
  public storeName: string;
  public storeOwner: string;
  public storeAddress: string;
  public description: string;
  public countryId: number;
  public zoneId: number;
  public storeEmail: string;
  public storeTelephone: string;
  public storeLanguageName: string;
  public storeImage: string;
  public isActive: string;
  public storeLogo: string;
  public storeLogoPath: string;
  public storeCurrencyId: number;
  public maintenanceMode: number;
  public emailLogo: string;
  public emailLogoPath: string;
  public invoiceLogo: string;
  public invoiceLogoPath: string;
  public qualityReviewQuestion: string;
  public designReviewQuestion: string;
  public comfortReviewQuestion: string;
  public valueForMoneyReviewQuestion: string;
  public contactUsEmail: string;
  public storeTelephone2: string;

  constructor(generalsettingresponse: any) {
    this.createdBy = generalsettingresponse.createdBy || '';
    this.createdDate = generalsettingresponse.createdDate || '';
    this.modifiedBy = generalsettingresponse.modifiedBy || '';
    this.modifiedDate = generalsettingresponse.modifiedDate || '';
    this.settingsId = generalsettingresponse.settingsId || '';
    this.storeName = generalsettingresponse.storeName || '';
    this.storeOwner = generalsettingresponse.storeOwner || '';
    this.storeAddress = generalsettingresponse.storeAddress || '';
    this.description = generalsettingresponse.description || '';
    this.countryId = generalsettingresponse.countryId || '';
    this.zoneId = generalsettingresponse.zoneId || '';
    this.storeEmail = generalsettingresponse.storeEmail || '';
    this.storeTelephone = generalsettingresponse.storeTelephone || '';
    this.storeLanguageName = generalsettingresponse.storeLanguageName || '';
    this.storeImage = generalsettingresponse.storeImage || '';
    this.isActive = generalsettingresponse.isActive || '';
    this.storeCurrencyId = generalsettingresponse.storeCurrencyId || '';
    this.storeLogo = generalsettingresponse.storeLogo || '';
    this.storeLogoPath = generalsettingresponse.storeLogoPath || '';
    this.maintenanceMode = generalsettingresponse.maintenanceMode || 0;
    this.qualityReviewQuestion=generalsettingresponse.qualityReviewQuestion||'',
    this.designReviewQuestion=generalsettingresponse.designReviewQuestion||'',
    this.comfortReviewQuestion=generalsettingresponse.comfortReviewQuestion||'',
    this.valueForMoneyReviewQuestion=generalsettingresponse.valueForMoneyReviewQuestion||''

    this.emailLogo = generalsettingresponse.emailLogo || '';
    this.emailLogoPath = generalsettingresponse.emailLogoPath || '';
    this.invoiceLogo = generalsettingresponse.invoiceLogo || '';
    this.invoiceLogoPath = generalsettingresponse.invoiceLogoPath || '';

    this.contactUsEmail = generalsettingresponse.contactUsEmail || '';
    this.storeTelephone2 = generalsettingresponse.storeTelephone2 || '';
  }
}
